export default {
  // Context menu items
  viewDetails: "View Details",
  viewDetailsShortcut: "View Details(ctrl+e)",
  noteNode: "Note Node",
  noteNodeShortcut: "Note Node(alt+v/⌥+v)",
  joinMonitoring: "Join Monitoring",
  joinMonitoringShortcut: "Join Monitoring(ctrl+m)",
  joinSurvey: "Join Survey",
  ordinarySurvey: "Ordinary Survey",
  keySurvey: "Key Survey",
  joinDashboard: "Join Dashboard",
  transactionDashboard: "Transaction Data Dashboard",
  balanceDashboard: "Balance Data Dashboard",
  aiModel: "AI Model",
  firstFeesModel: "First Fees Model",
  relatedFeesModel: "Related Fees Model",
  tornadoModel: "Tornado Model",
  newCanvas: "New Canvas",
  newCanvasShortcut: "New Canvas(alt+g/⌥+g)",
  copyAddress: "Copy Address",
  copyAddressShortcut: "Copy Address(ctrl+c)",

  // Notification messages
  noteSuccess: "Note added successfully!",
  noteFailed: "Failed to add note, please refresh and retry!",
  addedToSurvey: "Added to survey",
  notSupportMonitoring: "This address does not support monitoring!",
  notSupportModel: "This address does not support model verification!",
  submitSuccess: "Submitted successfully, waiting for verification result",
};
